import { Avatar } from "@mui/material";
import React, { useState } from "react";
import "../css/navbar.css";
import { useAuth } from "../contexts/AuthContext";
import { getRoleColor } from "../utils/roleColors";

export default function ProfileWidgetMobile(props) {
  const { currentUser } = useAuth();
  const [displayedName] = useState(currentUser ? currentUser.displayName : "");
  const [photoUrl] = useState(currentUser ? currentUser.photoURL : "");
  const roleColor = getRoleColor(props.userRole);

  return (
    <div className="widget-profile-container-mobile">
      <div className="avatar-container">
        <Avatar
          src={photoUrl}
          style={{
            width: "40px",
            height: "40px",
            border: "1px solid white",
          }}
        />
      </div>
      <div className="profil-widget-container-mobile">
        <div className="container-chip-role-profile">
          <div
            className="profil-name"
            title={displayedName}
            style={{ cursor: "pointer" }}
          >
            <span className="displayed-name-span">{displayedName}</span>
          </div>
        </div>
        <div className="container-chip-role-profile">
          <div className="profil-role-mobile" style={{ background: roleColor }}>
            {props.userRole}
          </div>
        </div>
      </div>
    </div>
  );
}
